/* eslint-disable max-len */
import imageBackgroundHaloClean from '../static/images/service-product/halo-clean.svg'
import imageHaloCleanFirst from '../static/images/service-product/halo-clean/1.svg'
import imageHaloCleanSecond from '../static/images/service-product/halo-clean/2.svg'
import imageHaloCleanThird from '../static/images/service-product/halo-clean/3.svg'
import imageHaloCleanFourth from '../static/images/service-product/halo-clean/4.svg'

import imageBackgroundHaloFix from '../static/images/service-product/halo-fix.svg'
import imageHaloFixFirst from '../static/images/service-product/halo-fix/1.svg'
import imageHaloFixSecond from '../static/images/service-product/halo-fix/2.svg'
import imageHaloFixThird from '../static/images/service-product/halo-fix/3.svg'
import imageHaloFixFourth from '../static/images/service-product/halo-fix/4.svg'

import imageBackgroundHaloMassage from '../static/images/service-product/halo-massage.svg'
import imageHaloMassageFirst from '../static/images/service-product/halo-massage/1.svg'
import imageHaloMassageSecond from '../static/images/service-product/halo-massage/2.svg'
import imageHaloMassageThird from '../static/images/service-product/halo-massage/3.svg'
import imageHaloMassageFourth from '../static/images/service-product/halo-massage/4.svg'
import imageHaloMassageFifth from '../static/images/service-product/halo-massage/5.svg'
import imageHaloMassageSixth from '../static/images/service-product/halo-massage/6.svg'
import imageHaloMassageSeventh from '../static/images/service-product/halo-massage/7.svg'
import imageHaloMassageEight from '../static/images/service-product/halo-massage/8.svg'
import imageHaloMassageNinth from '../static/images/service-product/halo-massage/9.svg'
import imageHaloMassageTen from '../static/images/service-product/halo-massage/10.svg'
import imageHaloMassageEleven from '../static/images/service-product/halo-massage/11.svg'
import imageHaloMassageTwelve from '../static/images/service-product/halo-massage/12.svg'
import imageHaloMassageThirteenth from '../static/images/service-product/halo-massage/13.svg'
import imageHaloMassageFourteenth from '../static/images/service-product/halo-massage/14.svg'

const serviceProduct = {
  HC: {
    imageBackground: imageBackgroundHaloClean,
    title: 'Pilihan Paket Halo Clean',
    products: [
      {
        id: 1,
        title: 'Paket Apartment/ Kost',
        subtitle: 'Paket bersih-bersih apartment atau kost',
        image: imageHaloCleanFirst
      },
      {
        id: 2,
        title: 'Paket Residensial',
        subtitle: 'Tidak perlu ribet bersih-bersih rumah Anda',
        image: imageHaloCleanSecond
      },
      {
        id: 3,
        title: 'Home Cleaning',
        subtitle: 'Layanan Home Cleaning paling tepat untuk rumah',
        image: imageHaloCleanThird
      },
      {
        id: 4,
        title: 'Office Cleaning',
        subtitle: 'Tetap jaga lingkungan kantor agar tetap bersih',
        image: imageHaloCleanFourth
      }
    ]
  },
  HF: {
    imageBackground: imageBackgroundHaloFix,
    title: 'Pilihan Paket Halo Fix',
    products: [
      {
        id: 1,
        title: 'Cuci AC',
        subtitle: 'Paket cuci AC aman, nyaman & lancar',
        image: imageHaloFixFirst
      },
      {
        id: 2,
        title: 'Bongkar AC',
        subtitle: 'Pastikan ruanganmu tetap dingin dengan layanan ini',
        image: imageHaloFixSecond
      },
      {
        id: 3,
        title: 'Pasang AC',
        subtitle: 'Pasang AC dimana saja, pasang dengan aman',
        image: imageHaloFixThird
      },
      {
        id: 4,
        title: 'Bongkar Pasang AC',
        subtitle: 'Pasang AC diruanganmu dan pastikan AC kamu...',
        image: imageHaloFixFourth
      }
    ]
  },
  HM: {
    imageBackground: imageBackgroundHaloMassage,
    title: 'Pilihan Paket Pijat Panggilan',
    subtitle:
      'Berbagai layanan terapi massage mulai dari perawatan tubuh dan kecantikan',
    products: [
      {
        id: 1,
        title: 'Full Spa Body Massage',
        subtitle: 'Pijatan Relaksasi dgn Teknik Pijatan dasar tradisional...',
        image: imageHaloMassageFirst
      },
      {
        id: 2,
        title: 'Serenity Spa Reflexolgy & Body Massage',
        subtitle: 'Relaksasi pijat tradisional...',
        image: imageHaloMassageSecond
      },
      {
        id: 3,
        title: 'Star Reflexology',
        subtitle: 'Relaksasi yang fokus kepada penekanan...',
        image: imageHaloMassageThird
      },
      {
        id: 4,
        title: 'Full Spa Body Massage + Kerokan',
        subtitle: 'Relaksasi Pijatan tradisional spa...',
        image: imageHaloMassageFourth
      },
      {
        id: 5,
        title: 'Full Spa Body Massage + Luluran',
        subtitle: 'Relaksasi Pijatan tradisional spa...',
        image: imageHaloMassageFifth
      },
      {
        id: 6,
        title: 'Full spa Body Massage Lulur + Masker Badan',
        subtitle: 'Scrub untuk mengangkat sel kulit mato...',
        image: imageHaloMassageSixth
      },
      {
        id: 7,
        title: 'Full Spa Massage + Perawatan Lengkap',
        subtitle: 'Layanan perawatan tubuh yang meliputi',
        image: imageHaloMassageSeventh
      },
      {
        id: 8,
        title: 'Hot Stone Spa Massage',
        subtitle: 'Relaksasi pijatan klasik hydroterapi...',
        image: imageHaloMassageEight
      },
      {
        id: 9,
        title: 'Massage + Totok wajah & Masker',
        subtitle: 'Relaksasi Pijatan tradisional sp...',
        image: imageHaloMassageNinth
      },
      {
        id: 10,
        title: 'Full Spa Body Massage+ Creambath',
        subtitle: 'Relaksasi pijatan tradisonal...',
        image: imageHaloMassageTen
      },
      {
        id: 11,
        title: 'Full Spa Body Massage + Dry Cupping',
        subtitle: 'Pijat relaksasi kesehatan untuk memperbaiki...',
        image: imageHaloMassageEleven
      },
      {
        id: 12,
        title: 'Sprain Massage',
        subtitle: 'Perawatan khusus untuk otot atau persendian ya...',
        image: imageHaloMassageTwelve
      },
      {
        id: 13,
        title: 'Pregnancy Massage',
        subtitle: 'Perawatan relaksasi khusus untuk ibu hamil',
        image: imageHaloMassageThirteenth
      },
      {
        id: 14,
        title: 'Mom & Baby Spa Massage',
        subtitle: 'Perawatan relaksasi khusus ibu dan bayi',
        image: imageHaloMassageFourteenth
      }
    ]
  }
}

const serviceProductType = {
  HC: 'HC',
  HF: 'HF',
  HM: 'HM'
}

export default {
  serviceProduct,
  serviceProductType
}
